import { Company } from '../../../api/companies/types';
import { Voucher } from '../../../api/vouchers/types';
import { PreReceiptState } from '../../../routes/Reservations/TravelFile/TravelFileHomePage/AccountingSection/GeneratePdfs/Receipt/PreReceiptState';
import { VoucherInfo } from '../../../api/vouchers/types';

export type PdfCompanyInfo = Pick<Company, 'name' | 'address' | 'fax' | 'iata' | 'phone' | 'website'>;
export type PdfBoxDataType = Array<{ label: string; value: number | string }>;
export type PdfMultipleTextBoxData = Array<Array<string>>;

export const DETAILS_REPAY_PAYMENT_REQUISITION = 'DETAILS_REPAY_PAYMENT_REQUISITION';

export type VouchersPdfPropsType = {
    info: BaseServiceVoucherInfoType;
} & Pick<Voucher, 'number' | 'type' | 'isPaid' | 'createdAt' | 'issueDate' | 'currency' | 'status'>;

export type BaseServiceVoucherInfoType = PreReceiptState & VoucherInfo;
